import { useContext } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { AiOutlineUserAdd } from "react-icons/ai";
import { BiDuplicate, BiUpload } from "react-icons/bi";
import ModalContext from "admin-panel/reservation/ModalContext";

import {
  publishTour,
  duplicateTour as duplication,
} from "services/adminTourList";

export default function TourCard({
  tour,
  colors,
  deleteTour,
  reservation,
  getInfo,
  setLoading,
}) {
  if (reservation) {
    var { changeTourId, editModalChanger, updateModal, changeFactorId } =
      useContext(ModalContext);
  }
  function clickHandler(type) {
    switch (type) {
      case 1:
        window.open(
          `/admin-panel/reservation/lists/insurance/${tour.id}`,
          "popup",
          "width=850,height=600"
        );
        break;
      case 2:
        window.open(
          `/admin-panel/reservation/lists/leader/${tour.id}`,
          "popup",
          "width=850,height=600"
        );
        break;
      default:
        console.log("Error");
    }
  }

  function duplicateTour() {
    Swal.fire({
      title: "آیا از کپی کردن این تور مطمئن هستید؟",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "بله",
      confirmButtonColor: "#198754",
      cancelButtonText: "خیر",
      cancelButtonColor: "#dc3545",
    }).then(async (res) => {
      if (res.isConfirmed) {
        setLoading(true);
        let result = await duplication(tour.id);
        if (result) {
          Swal.fire({
            title: "تور با موفقیت ایجاد شد.",
            icon: "success",
            showConfirmButton: false,
            timer: 1750,
          });
          await getInfo();
        } else {
          Swal.fire({
            title: "خطا!",
            text: "مشکلی در ایجاد تور پیش آمده است، لطفا بعدا تلاش کنید",
            icon: "error",
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#0d6efd",
          });
        }
        setLoading(false);
      }
    });
  }

  function publish() {
    Swal.fire({
      title: "آیا از انتشار تور مطمئن هستید؟",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "خیر",
      showConfirmButton: true,
      confirmButtonText: "بله",
    }).then(async (res) => {
      if (res.isConfirmed) {
        let result = await publishTour(tour.id);
        if (result) {
          Swal.fire({
            title: "عملیات با موفقیت انجام شد.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          getInfo();
        } else {
          Swal.fire({
            title: "خطا",
            text: "مشکلی در انجام عملیات بوجود آمده است.",
            icon: "error",
          });
        }
      }
    });
  }

  return (
    <div className={`col-lg-3 col-md-4 col-sm-6`} key={tour.id}>
      <div className={`card border-${colors[0]} m-1 mt-3`}>
        <div
          className={`card-header bg-${colors[0]} d-flex justify-content-between`}
        >
          <div>
            عنوان تور: <br />
            <span className="txt mx-2"> {tour.title} </span>
          </div>
          {reservation ? (
            <div
              className="cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#add-edit-reserve"
              style={{ cursor: "pointer" }}
              onClick={() => {
                changeTourId(tour.id);
                editModalChanger(false);
                updateModal();
                changeFactorId(-1);
              }}
            >
              <AiOutlineUserAdd
                data-bs-toggle="tooltip"
                title="ثبت نام"
              ></AiOutlineUserAdd>
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {"0,3".includes(tour.main_status) ? (
                  <BiUpload
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                    onClick={publish}
                    data-bs-toggle="tooltip"
                    title="انتشار تور"
                  ></BiUpload>
                ) : (
                  ""
                )}
                <BiDuplicate
                  style={{
                    cursor: "pointer",
                    fontSize: "20px",
                    marginRight: "10px",
                  }}
                  onClick={duplicateTour}
                  data-bs-toggle="tooltip"
                  title="تکرار تور"
                ></BiDuplicate>
              </div>
            </>
          )}
        </div>
        <div className={`card-body bg-${colors[1]}`}>
          <div>
            تاریخ:
            <span className="txt"> {tour.duration} </span>
          </div>
          <div className="mt-2">
            {tour.transferType != "" ? (
              <>
                ترنسفر:
                <span className="txt"> {tour.transferType} </span>
              </>
            ) : (
              <br />
            )}
          </div>
          {reservation ? (
            <div className="buttons d-flex justify-content-evenly mt-3">
              <button
                className="btn mx-2 p-1"
                style={{
                  fontSize: "13px",
                  border: "1px solid lightblue",
                  borderRadius: "5px",
                }}
                onClick={() => clickHandler(2)}
              >
                لیست تور لیدر
              </button>
              <button
                className="btn mx-2 p-1"
                style={{
                  fontSize: "13px",
                  border: "1px solid lightblue",
                  borderRadius: "5px",
                }}
                onClick={() => clickHandler(1)}
              >
                لیست بیمه
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        {!reservation ? (
          <div
            className={`card-footer bg-${colors[0]} d-flex justify-content-evenly`}
          >
            <Link
              to={`/single-tour/${tour.id}`}
              data-bs-toggle="tooltip"
              title="مشاهده جزئیات"
              target="_blank"
            >
              <img
                alt="not found"
                src="/image/eye.svg"
                className="cursor-pointer"
              />
            </Link>
            <div
              data-bs-toggle="tooltip"
              title="حذف"
              style={{ cursor: "pointer" }}
            >
              <img
                alt="not found"
                src="/image/trash.svg"
                className="cursor-pointer"
                onClick={() => deleteTour(tour.id)}
              />
            </div>
            <Link
              to={`/admin-panel/create-tour/${tour.id}`}
              data-bs-toggle="tooltip"
              title="ویرایش"
              target="_blank"
            >
              <img
                alt="not found"
                src="/image/pencil-square.svg"
                className="cursor-pointer"
              />
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
